import { render, staticRenderFns } from "./ProviderTable.vue?vue&type=template&id=7c30f019&scoped=true"
import script from "./ProviderTable.vue?vue&type=script&lang=js"
export * from "./ProviderTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c30f019",
  null
  
)

export default component.exports